<template>
    <v-animation-height height="auto">
        <contract-status />
    </v-animation-height>
</template>

<script>
import ContractStatus from './ContractStatus';

export default {
    name: 'contract-status-container',
    components: {
        ContractStatus,
    }
}
</script>


// WEBPACK FOOTER //
// ContractStatusContainer.vue?29ac5907